import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { AxiosRequestConfig } from "axios";

import { RootState } from "../index";
import httpClient from "../../utils/httpClient";

interface UserListType {
  id: string;
  displayName: string;
  email: string;
}
interface CtUserList {
  isLoading: boolean;
  data: UserListType[];
  error: string | null;
}

const initialState: CtUserList = {
  isLoading: false,
  data: [],
  error: null,
};

export interface ResponseError {
  message: string;
}
export interface RequestObject {
  searchText: string;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const searchUsers = createAsyncThunk<
  any,
  RequestObject,
  { rejectValue: ResponseError }
>("UsersSlice/getUserSearchData", async (requestObject, thunkApi) => {
  try {
    const response = await httpClient.post("/users", requestObject, {
      signal: thunkApi.signal,
    } as AxiosRequestConfig);
    if (response.status != 200) {
      if (response.data.Status == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to fetch search user list.",
        });
      }
    }
    return response.data;
  } catch (error: any) {
    if (thunkApi.signal.aborted) {
      return thunkApi.rejectWithValue({ message: "Request cancelled" });
    }
    return thunkApi.rejectWithValue({
      message: "Failed to fetch search user list.",
    });
  }
});

const CTDBProductContactListSlice = createSlice({
  name: "CTDBProductContactListSlice",
  initialState,
  reducers: {
    resetSearchUsers: (state) => {
      state.isLoading = false;
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = [];
      })
      .addCase(
        searchUsers.fulfilled,
        (state, action: PayloadAction<UserListType[]>) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        },
      )
      .addCase(searchUsers.rejected, (state, action: any) => {
        if (
          action.meta?.aborted ||
          action.payload?.message === "Request cancelled"
        ) {
          return;
        }
        state.isLoading = false;
        state.data = [];
        state.error = action.payload;
      });
  },
});

export const selectUserList = (state: RootState) => {
  return state.CTDBUserListSlice;
};

export const { resetSearchUsers } = CTDBProductContactListSlice.actions;
export default CTDBProductContactListSlice.reducer;
